class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.autoCloseTimer = null;
    this.autoCloseDelay = 3000; // 3 sek
    this.closeAnimationMs = 300;

    this.cartItemKey = null;
    this.activeElement = null;

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    this.notification.addEventListener('mouseenter', () => this.clearAutoClose());
    this.notification.addEventListener('focusin', () => this.clearAutoClose());

    this.notification.addEventListener('mouseleave', () => {
      if (this.notification.classList.contains('active')) {
        this.scheduleAutoClose();
      }
    });

    this.notification.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (
          this.notification.classList.contains('active') &&
          !this.notification.contains(document.activeElement)
        ) {
          this.scheduleAutoClose();
        }
      }, 0);
    });
  }

  clearAutoClose() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  scheduleAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimer = window.setTimeout(() => {
      this.close();
    }, this.autoCloseDelay);
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.remove('is-closing');
    this.notification.classList.add('animate', 'active');

    window.setTimeout(() => {
      this.notification.focus();

      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }
    }, 10);

    document.body.addEventListener('click', this.onBodyClick);
    this.scheduleAutoClose();
  }

  close() {
    if (!this.notification) return;
    if (!this.notification.classList.contains('active')) return;

    this.notification.classList.add('is-closing');
    this.clearAutoClose();
    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    window.setTimeout(() => {
      this.notification.classList.remove('active', 'is-closing');
    }, this.closeAnimationMs);
  }

  renderContents(parsedState) {
    if (!this.notification || !parsedState) return;

    this.cartItemKey = parsedState.key || null;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (!sectionHtml) return;

      const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (innerHtml !== null) {
        container.innerHTML = innerHtml;
      }
    });

    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartItemKey
          ? `#cart-notification-product-${CSS.escape(this.cartItemKey)}`
          : '#cart-notification-product',
      },
      {
        id: 'cart-notification-button',
        selector: '#cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);

    if (!element) {
      if (selector === '#cart-notification-product') {
        const fallback = doc.querySelector('#cart-notification-product');
        return fallback ? fallback.innerHTML : null;
      }
      return null;
    }

    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target === this.notification || target.closest('cart-notification')) return;

    const disclosure = target.closest('details-disclosure, header-menu');
    this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);